'use strict';

import versioner from '../versioner';
import process from './process';

versioner['arvada_sewer_after_hours'] = {
	process: process,
}

versioner['arvada_water_after_hours'] = {
	process: process,
}

const MODULE_NAME = 'daupler.incidents.versions.arvada';

export default MODULE_NAME;
